module.exports = __webpack_public_path__ + "img/active-tournament.6f68a925.jpg";